<div tabindex="0" class="dropdown open show" [off-click]="clickedOutside">
  <!-- Control display -->
  <div [class.disabled]="disabled">
    <div class="relative">
      <span
        tabindex="-1"
        class="input pr-10"
        [class.selected-container-text]="!multiple"
        [class.selected-container-item]="multiple"
        (click)="toggle($event)">
        @if (selection.length <= 0) {
          <span class="ui-select-placeholder text-muted">{{ placeholder }}</span>
        }
        @for (itm of selection; track itm.id; let idx = $index) {
          <span>
            @if (moreLoaded || maxVisibleItemCount === 0 || idx < maxVisibleItemCount) {
              <span
                [class.selected-item-text]="!multiple"
                [class.selected-item-item]="multiple"
                [class.btn]="multiple"
                [class.btn-default]="multiple"
                [class.btn-xs]="multiple">
                {{ itm.text }}
                @if (multiple && !disabled) {
                  <a class="close" (click)="removeItem($event, itm)">x</a>
                }
              </span>
            }
          </span>
        }
      </span>
      <span class="icon text-sm float-right">
        <mat-icon>arrow_drop_down</mat-icon>
      </span>
    </div>
  </div>
  <div class="enabled">
    @if (showMoreLink) {
      <span class="pull-right more-items-icon" (click)="loadMore($event)">(...)</span>
    }
    <i class="caret pull-right" (click)="toggle($event)"></i>
  </div>

  <!-- options template -->
  @if (!disabled && isOpen && internalItems && internalItems.length > 0) {
    <ul class="dropdown-menu">
      <div style="padding: 5px">
        @if (allowFilter) {
          <input
            name="filterText"
            type="text"
            [(ngModel)]="filter"
            (click)="setInputFocus()"
            (blur)="setInputFocusOut()"
            class="input"
            placeholder="{{ filterPlaceholder }}"
            [ngModelOptions]="{ standalone: true }"
            autocomplete="off" />
        }
      </div>
      @for (o of internalItems | itemPipe: filter; track o.id) {
        <li role="menuitem">
          <tree-select-item [item]="o" [onTouchedCallBack]="onTouchedCallback"></tree-select-item>
        </li>
      }
    </ul>
  }
</div>
